// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteModal_root__rAbOm","title":"DeleteModal_title__VqxA8","buttons":"DeleteModal_buttons__1EmcP","button":"DeleteModal_button__39yPr","icon":"DeleteModal_icon__6RYUL"};